export default "__VITE_ASSET__BFZjgjyZ__"